import { HeroOptions } from '@/types/models/Post.model'
import { isNonEmptyString } from '@/utils/checks'
import {
  isImageBlogHero,
  isVideoBlogHeroWithCoverImage
} from './blogHeroChecks'

const BASE_CLOUDINARY_TRANSFORMATION_URL =
  'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_800,w_3200'

export const blogCoverImageHandler = ({
  heroOptions,
  slug
}: {
  heroOptions: HeroOptions
  slug: string
}): string | null => {
  if (
    isVideoBlogHeroWithCoverImage({ heroOptions }) &&
    isNonEmptyString(heroOptions?.coverImage)
  ) {
    return heroOptions?.coverImage
  }
  if (
    isImageBlogHero({ heroOptions }) &&
    isNonEmptyString(heroOptions?.mediaSrc)
  ) {
    return heroOptions?.mediaSrc
  }
  if (!isNonEmptyString(slug)) {
    return null
  }

  return `${BASE_CLOUDINARY_TRANSFORMATION_URL}/${slug}`
}
